const loginBtn = document.querySelector(`.header-btn[data-test="header-login-button"]`);
export const isLoggedIn = loginBtn == null;
export const openLoginModal = () => {
    loginBtn?.click();
};
